import product1 from '../images/placeholders/products/product1.jpg'
import product2 from '../images/placeholders/products/product2.jpg'
import product3 from '../images/placeholders/products/product3.jpg'
import product4 from '../images/placeholders/products/product4.jpg'
import product5 from '../images/placeholders/products/product5.jpg'

const OfferBox = () => {
    return (
        <div className='w-full flex flex-col md:items-center'>
            <h4>Prodotti in offerta oggi all'Osteria Nonna Titti:</h4>
            <div className="w-full flex overflow-scroll p-4 gap-4 md:justify-center">
                <div className="w-[200px] aspect-w-2 aspect-h-3 flex flex-col gap-2">
                    <img src={product1} alt="" className='w-full h-full object-cover object-center rounded-lg hover:scale-110' />
                    <span className='text-sm md:text-lg flex justify-center whitespace-nowrap'>Lugana Olivini</span>
                </div>
                <div className="w-[200px] aspect-w-2 aspect-h-3 flex flex-col gap-2">
                    <img src={product2} alt="" className='w-full h-full object-cover object-center rounded-lg hover:scale-110' />
                    <span className='text-sm md:text-lg flex justify-center whitespace-nowrap'>Ravioli patate e funghi</span>
                </div>
                <div className="w-[200px] aspect-w-2 aspect-h-3 flex flex-col gap-2">
                    <img src={product3} alt="" className='w-full h-full object-cover object-center rounded-lg hover:scale-110' />
                    <span className='text-sm md:text-lg flex justify-center whitespace-nowrap'>Spaghetti Rey</span>
                </div>
            </div>
        </div>
    )
}

export default OfferBox;